<script setup>
import { ACCOUNT_NAV_ITEMS } from '@/constants/AccountConstants.ts'
import { translate } from '@/plugins/i18n.js'
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()

const currentAction = computed(() => route.params.action)

const getItemRoute = (action) => ({
  name: 'account_action',
  params: { action }
})

const isActive = (action) => currentAction.value === action
</script>

<template>
  <VSheet class="overflow-hidden">
    <VList nav>
      <VListItem
        v-for="item in ACCOUNT_NAV_ITEMS"
        :key="item.action"
        :to="getItemRoute(item.action)"
        :active="isActive(item.action)"
      >
        <VListItemTitle class="font-weight-bold font-size-s">
          {{ translate(item.labelKey) }}
        </VListItemTitle>
        <VListItemSubtitle class="font-size-xs account-navigation__subtitle">
          {{ translate(item.descriptionKey) }}
        </VListItemSubtitle>
      </VListItem>
    </VList>
  </VSheet>
</template>
